import z from 'zod';

export const sheetSearchSchema = z.object({
  sheetId: z.string().optional(),
  sheetRevision: z.coerce.number().int().positive().optional(),
  sheetTab: z.string().optional(),
  sheetRow: z.string().optional(),
  commentId: z.string().optional(),
});
